import { render, staticRenderFns } from "./PigeanTable.vue?vue&type=template&id=4925642a&scoped=true&"
import script from "./PigeanTable.vue?vue&type=script&lang=js&"
export * from "./PigeanTable.vue?vue&type=script&lang=js&"
import style0 from "./PigeanTable.vue?vue&type=style&index=0&id=4925642a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925642a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4925642a')) {
      api.createRecord('4925642a', component.options)
    } else {
      api.reload('4925642a', component.options)
    }
    module.hot.accept("./PigeanTable.vue?vue&type=template&id=4925642a&scoped=true&", function () {
      api.rerender('4925642a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PigeanTable.vue"
export default component.exports